module.exports = __webpack_public_path__ + "img/physicalConditioning.3ed765fe.svg";